import React, { useEffect, useState } from 'react';
import { deleteWishlistById, getWishlistProductsByCustomerId } from '../../service/WishlistService';
import Topbar from './Navigations/Topbar'; // Adjust path as needed
import Footer from '../Footer'; // Adjust path as needed
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { createCart, getCartProductsByCustomerId } from '../../service/CartService'; // Adjust path
import { useToast } from '../toast/ToastProvider'; // Adjust path
import ProductCard from './Card/ProductCard';

const Wishlist = () => {
  const [wishlists, setWishlist] = useState([]);
  const [cart, setCart] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const toast = useToast();
  const navigate = useNavigate();
  const [loadingItem, setLoadingItem] = useState(null);

  const fetchWishlistData = async () => {
    if (!authUser?.id) return;
    try {
      const response = await getWishlistProductsByCustomerId(authUser.id);
      setWishlist(response || []);
    } catch (error) {
      console.error("Failed to fetch wishlist:", error);
      toast("Failed to load wishlist", "ERROR");
    }
  };

  // Fetch cart to check if product is already added
  const fetchCartData = async () => {
    if (!authUser?.id) return;
    try {
      const cartData = await getCartProductsByCustomerId(authUser.id);
      setCart(cartData || []);
    } catch (error) {
      console.error("Failed to fetch cart:", error);
      toast("Failed to load cart", "ERROR");
    }
  };

  const handleRemoveFromWishlist = async (wishlistId) => {
    setLoadingItem(wishlistId); // start loader for this item
    try {
      await deleteWishlistById(wishlistId);
      toast("Removed from wishlist", "SUCCESS");
      setWishlist((prev) => prev.filter((item) => item.wishlistId !== wishlistId));
    } catch (error) {
      console.error("Failed to remove wishlist item:", error);
      toast("Failed to remove from wishlist", "ERROR");
    } finally {
      setLoadingItem(null); // stop loader
    }
  };

  // Add to cart handler
  const addToCart = async (productId) => {
    if (!authUser) {
      navigate("/login");
      return;
    }

    try {
      await createCart({ customerId: authUser.id, productId, quantity: 1 });
      toast("Product added to cart", "SUCCESS");
      fetchCartData(); // Refresh cart state
    } catch (error) {
      toast("Failed to add product to cart", "ERROR");
    }
  };

  const handleGoToCart = () => {
    navigate("/shopping-cart");
  };

  const isProductInCart = (productId, customerId) => {
    return cart.some((item) => item.productId === productId && item.customerId === customerId);
  };


  // useEffect(() => {

  //   fetchWishlistData();
  //   fetchCartData();
  // }, [authUser?.id]);
  useEffect(() => {
    if (authUser?.id) {
      fetchWishlistData();
      fetchCartData();
    }
  }, [authUser?.id]);


  const styles = {
    productItem: {
      listStyle: "none",
      marginBottom: "30px",
    },
    productInner: {
      background: "#fff",
      borderRadius: "16px",
      overflow: "hidden",
      transition: "all 0.3s ease",
      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
      position: "relative",
      height: "100%",
    },
    flash: {
      background: "#c05c2e",
      color: "#fff",
      fontSize: "12px",
      fontWeight: 600,
      textTransform: "uppercase",
      padding: "4px 10px",
      borderRadius: "12px",
      position: "absolute",
      top: "12px",
      left: "12px",
      zIndex: 2,
    },
    productThumb: {
      position: "relative",
      textAlign: "center",
      height: "250px",
      overflow: "hidden",
    },
    productImg: {
      width: "100%",
      height: "100%",
      objectFit: "fill",
      transition: "transform 0.3s ease",
    },
    productInfo: {
      padding: "15px",
      textAlign: "center",
    },
    productName: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#222",
      textDecoration: "none",
    },
    heartBtn: {
      background: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "20px",
      position: "absolute",
      top: "12px",
      right: "12px",
      zIndex: 2,
      color: "red",
    },
    loader: {
      width: "20px",
      height: "20px",
      border: "2px solid #f3f3f3",
      borderTop: "2px solid red",
      borderRadius: "50%",
      animation: "spin 0.8s linear infinite",
    },
  };


  return (
    <div>
      <header className="header style7">
        <Topbar />
      </header>

      <div className="main-content main-content-product left-sidebar">
        <div className="container">
          <div className="row pt-4 pb-2">
            <div className="col-lg-12">
              <div className="breadcrumb-trail breadcrumbs">
                <ul className="trail-items breadcrumb">
                  <li className="trail-item trail-begin">
                    <Link to="/" className="text-decoration-none">
                      Home
                    </Link>
                  </li>
                  <li className="trail-item trail-end active">Wishlist</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="content-area shop-grid-content no-banner">
              <h3 className="py-3">My Wishlist</h3>

              {wishlists.length === 0 ? (
                <p className="text-center py-5 fs-2">Your wishlist is empty.</p>
              ) : (
                <ul className="row list-products auto-clear equal-container product-grid">
                  {wishlists.map((item, index) => {
                    const inCart = isProductInCart(
                      item.productId,
                      authUser?.id
                    );
                    return (
                      <ProductCard
                        key={index}
                        data={item}
                        styles={styles}
                        inCart={inCart}
                        inWishlist={true}
                        isFromWishlist={true}
                        onAddToCart={addToCart}
                        onGoToCart={handleGoToCart}
                        onRemoveFromWishlist={handleRemoveFromWishlist}
                        loadingItem={loadingItem}
                      />
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{wishlists.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wishlist;